module.exports = __webpack_public_path__ + "assets/img/88_725.db1f8312.jpg";